module.exports = __webpack_public_path__ + "img/dsci0096.cd22340e.jpg";